import { GridLayout } from '@view-model/ui/layouts';
import { VIEW_GRID_SIZE } from 'balus-common';

// ビューのサイズ変更単位。バックエンドのレイアウト検証と共有するため balus-common で定義している
export { VIEW_GRID_SIZE };
export const MIN_VIEW_WIDTH = VIEW_GRID_SIZE * 2;
export const MIN_VIEW_HEIGHT = VIEW_GRID_SIZE * 3;

export const viewGridLayout = new GridLayout(VIEW_GRID_SIZE, VIEW_GRID_SIZE);
